export interface MovieItem {
  id: string;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  subCategory: string;
  year: number;
  rating: number;
  description: string;
  descriptionLong: string;
  coverImage: string;
  bannerImage: string;
  episodes: string;
  status: string;
  actors: string[];
  director: string;
  region: string;
  language: string;
  releaseDate: string;
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
}

export const moviesData: MovieItem[] = [
  {
    id: 'movie-001',
    title: '流浪地球3',
    category: 'movie',
    subCategory: '科幻',
    year: 2026,
    rating: 8.9,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，一场关乎人类命运的宏大冒险再度开启。',
    descriptionLong: '在不远的未来，太阳急速衰老膨胀，地球面临被吞没的灭顶之灾。为拯救地球，人类在地球表面建造了上万座行星发动机，以逃离太阳系寻找新的家园，地球和人类就此踏上预计长达2500年的宇宙流浪之旅。在完成这一宏伟计划的进程中，无数人挺身而出，上演了可歌可泣的传奇故事。第三部将聚焦于地球在星际航行中遭遇的全新危机，人类文明面临前所未有的挑战。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20dramatic%20cinematic%20lighting%2C%20warm%20gold%20and%20deep%20blue%20tones%2C%20clean%20professional%20movie%20poster%20composition%2C%20minimalist%20background&width=400&height=560&seq=movie-cover-001&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20landscape%2C%20massive%20planetary%20engines%20on%20Earth%20surface%2C%20dramatic%20space%20vista%2C%20warm%20golden%20atmospheric%20lighting%2C%20cinematic%20composition%2C%20hero%20banner%20style%2C%20clean%20dark%20gradient%20edges&width=1400&height=600&seq=movie-banner-001&orientation=landscape',
    episodes: '1集全',
    status: '已完结',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    director: '郭帆',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-02-10',
    updateInfo: '2026-02-10 更新至完整版',
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-002',
    title: '满江红2',
    category: 'movie',
    subCategory: '历史/悬疑',
    year: 2026,
    rating: 8.5,
    description: '南宋绍兴年间，一场围绕岳飞遗言的惊天谜案悄然展开。各路人马暗藏心机，在重重谜局中展开殊死较量。',
    descriptionLong: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇命案牵扯出惊天秘密，各方势力暗流涌动。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这巨大阴谋之中，他们被迫在限定的一个时辰内找到真相。随着调查深入，一个埋藏多年的秘密逐渐浮出水面，关乎忠义、关乎家国。',
    coverImage: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%2C%20ancient%20palace%20courtyard%20setting%2C%20dramatic%20red%20and%20gold%20color%20scheme%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20lighting%2C%20movie%20poster%20layout%2C%20clean%20background&width=400&height=560&seq=movie-cover-002&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20dramatic%20shadows%2C%20lanterns%20hanging%2C%20historical%20drama%20atmosphere%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition%2C%20dark%20vignette&width=1400&height=600&seq=movie-banner-002&orientation=landscape',
    episodes: '1集全',
    status: '已完结',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    director: '张艺谋',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-01-22',
    updateInfo: '2026-01-22 已完结',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-003',
    title: '孤注一掷',
    category: 'movie',
    subCategory: '犯罪/剧情',
    year: 2025,
    rating: 8.7,
    description: '程序员潘生和模特安娜被高薪招聘所吸引，来到海外追寻财富梦想，却意外落入境外诈骗工厂的陷阱中。',
    descriptionLong: '电影取材自上万起真实诈骗案例，讲述了程序员潘生和模特安娜被海外高薪招聘吸引，出国淘金却意外落入境外诈骗工厂陷阱的故事。在这个充满诱惑与危险的境外世界，他们必须想尽一切办法逃离魔窟。影片真实还原了境外网络诈骗的全产业链，揭示了人性的贪婪与脆弱。',
    coverImage: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%2C%20dark%20urban%20setting%20with%20neon%20lights%2C%20suspenseful%20atmosphere%2C%20warm%20amber%20and%20dark%20tones%2C%20professional%20movie%20poster%20design%2C%20minimalist%20clean%20composition&width=400&height=560&seq=movie-cover-003&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20urban%20Southeast%20Asian%20cityscape%20at%20night%2C%20neon%20signs%2C%20gritty%20atmosphere%2C%20crime%20thriller%20cinematic%20look%2C%20warm%20amber%20street%20lights%2C%20dramatic%20cinematography%2C%20hero%20banner%20style&width=1400&height=600&seq=movie-banner-003&orientation=landscape',
    episodes: '1集全',
    status: '已完结',
    actors: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    director: '申奥',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-08-08',
    updateInfo: '2025-08-08 已完结',
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-004',
    title: '热辣滚烫',
    category: 'movie',
    subCategory: '喜剧/剧情',
    year: 2025,
    rating: 8.3,
    description: '善良的乐莹在经历了一系列生活打击后，意外结识了拳击教练昊坤，从此开启了热辣滚烫的人生新篇章。',
    descriptionLong: '乐莹是一个善良、真诚的女孩，但她的人生却屡遭挫折。在接连经历了失恋、失业等一系列打击后，她偶然结识了拳击教练昊坤。在昊坤的帮助下，乐莹开始接触拳击运动，这项看似与她格格不入的运动却给了她全新的人生方向。她在拳击中找到自信，找到力量，也找到了真正属于自己的人生。',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20inspiring%20comedy%20drama%20movie%20poster%2C%20boxing%20gym%20setting%20with%20soft%20warm%20lighting%2C%20uplifting%20atmosphere%2C%20golden%20and%20cream%20color%20palette%2C%20professional%20movie%20poster%20design%2C%20clean%20background&width=400&height=560&seq=movie-cover-004&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Warm%20sunlit%20boxing%20gym%20interior%2C%20soft%20golden%20light%20streaming%20through%20windows%2C%20inspiring%20atmosphere%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition%2C%20warm%20cream%20and%20gold%20tones&width=1400&height=600&seq=movie-banner-004&orientation=landscape',
    episodes: '1集全',
    status: '已完结',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    director: '贾玲',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-02-10',
    updateInfo: '2025-02-10 已完结',
    isHot: false,
    isNew: false,
  },
  {
    id: 'tv-001',
    title: '狂飙',
    category: 'tv',
    subCategory: '犯罪/剧情',
    year: 2025,
    rating: 9.2,
    description: '京海市一线刑警安欣与黑恶势力高启强展开长达二十年的正邪较量，展现了扫黑除恶的艰辛历程。',
    descriptionLong: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子，粉碎了黑恶势力的保护伞，一举铲除了盘踞京海多年的强盛集团。这部剧展现了扫黑除恶工作的艰辛与壮烈，安欣与高启强长达二十年的对抗，折射出中国社会法治进程的深刻变革。',
    coverImage: 'https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20poster%2C%20Chinese%20police%20and%20underworld%20theme%2C%20dark%20atmosphere%20with%20warm%20street%20light%2C%20intense%20dramatic%20composition%2C%20professional%20series%20poster%20design%2C%20clean%20minimal%20background&width=400&height=560&seq=movie-cover-005&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Chinese%20city%20street%20at%20night%2C%20rain%20soaked%20roads%2C%20warm%20street%20lamps%2C%20crime%20drama%20atmosphere%2C%20cinematic%20wide%20shot%2C%20dark%20and%20moody%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-005&orientation=landscape',
    episodes: '39集全',
    status: '已完结',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    director: '徐纪周',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-01-14',
    updateInfo: '全39集 已完结',
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv-002',
    title: '庆余年2',
    category: 'tv',
    subCategory: '古装/权谋',
    year: 2026,
    rating: 9.0,
    description: '范闲在经历生死考验后，重返京都，面对更加复杂的朝堂局势和更加凶险的阴谋算计。',
    descriptionLong: '范闲在经历了第一季的生死考验后，对这个世界有了更深刻的认识。他带着林婉儿回到了京都，却发现京都的局势比之前更加复杂。各方势力暗流涌动，庆帝的心思更加深不可测。范闲凭借自己的智慧和勇气，在权谋的漩涡中周旋，同时也在寻找着自己身世的真相。这部剧集延续了第一季的高水准制作，权谋布局更为宏大，人物关系更加错综复杂。',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20poster%2C%20elegant%20traditional%20costume%2C%20palace%20setting%20with%20warm%20golden%20light%2C%20historical%20aesthetic%2C%20professional%20series%20poster%20design%2C%20clean%20minimal%20composition&width=400&height=560&seq=movie-cover-006&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%2C%20golden%20sunset%20light%2C%20traditional%20architecture%2C%20dramatic%20and%20elegant%20atmosphere%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-006&orientation=landscape',
    episodes: '更新至36集',
    status: '连载中',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    director: '孙皓',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-05-16',
    updateInfo: '2026-08-02 更新至第36集',
    isHot: true,
    isNew: true,
  },
  {
    id: 'tv-003',
    title: '三体',
    category: 'tv',
    subCategory: '科幻/悬疑',
    year: 2026,
    rating: 8.8,
    description: '纳米科学家汪淼在警官史强的帮助下，揭开了地球基础科学研究异常背后的惊天秘密——外星文明"三体"的存在。',
    descriptionLong: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。纳米科学家汪淼被警官史强带到了联合作战中心，潜入名为"科学边界"的组织协助调查。在调查过程中，汪淼接触到了一个名为"三体"的神秘VR游戏，这个游戏呈现了一个拥有三颗恒星的奇异世界。随着调查的深入，汪淼和史强逐渐发现，这一切背后隐藏着一个关于外星文明的巨大秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%2C%20cosmic%20and%20mysterious%20atmosphere%2C%20three%20suns%20in%20alien%20sky%2C%20dark%20and%20warm%20tones%2C%20professional%20series%20poster%20design%2C%20clean%20minimal%20composition&width=400&height=560&seq=movie-cover-007&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20landscape%20with%20three%20suns%2C%20alien%20planet%20surface%2C%20sci-fi%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition%2C%20warm%20amber%20tones&width=1400&height=600&seq=movie-banner-007&orientation=landscape',
    episodes: '更新至30集',
    status: '连载中',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    director: '杨磊',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-01-15',
    updateInfo: '2026-08-01 更新至第30集',
    isHot: true,
    isNew: true,
  },
  {
    id: 'tv-004',
    title: '繁花',
    category: 'tv',
    subCategory: '剧情/年代',
    year: 2025,
    rating: 8.9,
    description: '九十年代的上海，阿宝凭借自己的智慧和魄力，在商海沉浮中从默默无闻到成为黄河路上叱咤风云的宝总。',
    descriptionLong: '九十年代的上海，处处是机遇，也处处是挑战。小人物阿宝凭借自己的聪明才智和过人胆识，在商海中披荆斩棘，从黄河路上一家小饭馆的常客，一步步成为叱咤风云的宝总。在这个过程中，他经历了爱情的甜蜜与苦涩，友情的真挚与背叛。上海的霓虹灯下，每个人都在书写着自己的传奇。这部剧以精致考究的画面，完美还原了九十年代上海的独特风貌与时代气息。',
    coverImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20series%20poster%2C%20vintage%20neon%20lights%2C%20elegant%20nostalgic%20atmosphere%2C%20warm%20golden%20and%20amber%20tones%2C%20professional%20series%20poster%20design%2C%20clean%20minimal%20composition&width=400&height=560&seq=movie-cover-008&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20at%20night%2C%20vintage%20neon%20signs%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20street%20lights%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition%2C%20elegant%20retro%20style&width=1400&height=600&seq=movie-banner-008&orientation=landscape',
    episodes: '30集全',
    status: '已完结',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    director: '王家卫',
    region: '中国大陆',
    language: '汉语普通话/沪语',
    releaseDate: '2025-12-27',
    updateInfo: '全30集 已完结',
    isHot: false,
    isNew: false,
  },
  {
    id: 'variety-001',
    title: '奔跑吧·第12季',
    category: 'variety',
    subCategory: '户外真人秀',
    year: 2026,
    rating: 8.1,
    description: '常驻嘉宾与新加入的飞行嘉宾一起，在全国各地展开充满欢笑的竞技游戏，传递积极向上的生活态度。',
    descriptionLong: '《奔跑吧》第十二季继续由李晨、郑恺、沙溢等老成员领衔，同时迎来多位实力派新嘉宾的加入。本季节目将在全国各地取景，精心设计了更多充满创意和挑战性的游戏环节。在欢笑声中，嘉宾们将展现团结协作的精神，传递积极向上的能量。每一期节目都是一次充满惊喜和感动的旅程。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20outdoor%20adventure%20game%20theme%2C%20bright%20cheerful%20atmosphere%2C%20warm%20sunny%20lighting%2C%20group%20of%20celebrities%20running%2C%20professional%20show%20poster%20design%2C%20clean%20background&width=400&height=560&seq=movie-cover-009&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Sunny%20outdoor%20Chinese%20landscape%20with%20green%20hills%2C%20bright%20cheerful%20atmosphere%2C%20variety%20show%20scene%2C%20warm%20golden%20sunlight%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-009&orientation=landscape',
    episodes: '更新至第8期',
    status: '连载中',
    actors: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    director: '姚译添',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-04-25',
    updateInfo: '2026-08-02 更新至第8期',
    isHot: true,
    isNew: true,
  },
  {
    id: 'variety-002',
    title: '向往的生活·第8季',
    category: 'variety',
    subCategory: '生活纪实',
    year: 2026,
    rating: 8.4,
    description: '黄磊和何炅带领新老朋友们回归田园，在宁静的林间小屋中，体验自给自足的慢生活，招待远道而来的客人。',
    descriptionLong: '《向往的生活》第八季来到了一个新的世外桃源——一处隐匿在江南山水间的林间小屋。黄磊和何炅带领着新老朋友们在这里过着自给自足的生活，每天种菜、做饭、聊天、唱歌，用最朴实的方式享受生活。每一期都会有新朋友来蘑菇屋做客，他们带来各自的故事，分享人生的感悟。在这个快节奏的时代，这个节目为观众提供了一方慢下来的净土。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20living%20variety%20show%20poster%2C%20cozy%20forest%20cottage%20setting%2C%20warm%20natural%20lighting%2C%20peaceful%20rural%20atmosphere%2C%20green%20plants%20and%20flowers%2C%20professional%20show%20poster%20design&width=400&height=560&seq=movie-cover-010&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20with%20small%20wooden%20cottage%2C%20green%20forest%20surrounding%2C%20warm%20morning%20sunlight%2C%20idyllic%20rural%20scene%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-010&orientation=landscape',
    episodes: '更新至第10期',
    status: '连载中',
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    director: '王征宇',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-04-18',
    updateInfo: '2026-08-01 更新至第10期',
    isHot: false,
    isNew: true,
  },
  {
    id: 'variety-003',
    title: '歌手·2026',
    category: 'variety',
    subCategory: '音乐竞演',
    year: 2026,
    rating: 8.7,
    description: '顶级歌手集结，以最纯粹的音乐实力展开激烈竞演，每一场都是听觉的盛宴，用歌声征服观众的耳朵。',
    descriptionLong: '《歌手·2026》汇聚了华语乐坛最强音，来自不同年代、不同风格的顶尖歌手齐聚一堂，在舞台上展现最纯粹的音乐魅力。没有花哨的包装，只有实力与实力的碰撞。每一位歌手都以自己的方式重新诠释经典，用歌声讲述故事，用旋律传递情感。这是一场关于音乐的巅峰对决，也是对华语乐坛的一次深情致敬。',
    coverImage: 'https://readdy.ai/api/search-image?query=Music%20competition%20variety%20show%20poster%2C%20elegant%20stage%20spotlight%2C%20dramatic%20concert%20atmosphere%2C%20warm%20golden%20stage%20lighting%2C%20professional%20show%20poster%20design%2C%20clean%20dark%20background&width=400&height=560&seq=movie-cover-011&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20spotlights%2C%20elegant%20theater%20atmosphere%2C%20warm%20golden%20lighting%2C%20professional%20music%20performance%20setting%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-011&orientation=landscape',
    episodes: '更新至第6期',
    status: '连载中',
    actors: ['那英', '汪峰', '张靓颖', '周深', '华晨宇'],
    director: '洪涛',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-05-09',
    updateInfo: '2026-08-03 更新至第6期',
    isHot: true,
    isNew: true,
  },
  {
    id: 'anime-001',
    title: '斗破苍穹·年番',
    category: 'anime',
    subCategory: '玄幻/热血',
    year: 2026,
    rating: 8.6,
    description: '天才少年萧炎在创造了家族辉煌修炼纪录后突然陨落，在戒指中药老灵魂的指导下，一步步踏上巅峰强者之路。',
    descriptionLong: '萧炎，曾是萧家历史上空前绝后的天才，十岁便凝聚气旋，成为斗者。然而在他十一岁那年，一切都变了——他的斗气在一夜之间消失殆尽，从此沦为废柴。三年之后，纳兰嫣然上门退婚，萧炎立下三年之约。机缘巧合之下，萧炎唤醒了戒指中的灵魂——药老。在药老的悉心教导下，萧炎重新踏上了修炼之路，一步步走向强者之巅，终将让所有小看他的人刮目相看。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20poster%2C%20martial%20arts%20theme%2C%20young%20hero%20with%20flame%20powers%2C%20dynamic%20action%20pose%2C%20warm%20fire%20color%20palette%2C%20professional%20anime%20poster%20design%2C%20clean%20background&width=400&height=560&seq=movie-cover-012&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20flame%20and%20fire%20elements%2C%20dramatic%20sky%2C%20wuxia%20anime%20style%2C%20warm%20golden%20and%20crimson%20tones%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-012&orientation=landscape',
    episodes: '更新至第82集',
    status: '连载中',
    actors: ['张沛', '刘琮', '沈念如', '宝木中阳'],
    director: '赵丙乐',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-07-01',
    updateInfo: '2026-08-03 更新至第82集',
    isHot: true,
    isNew: true,
  },
  {
    id: 'anime-002',
    title: '完美世界',
    category: 'anime',
    subCategory: '玄幻/热血',
    year: 2026,
    rating: 8.5,
    description: '石昊出生在下界石国，为寻找失踪的父母，他踏上了一条充满艰险的修炼之路，誓要成为这天地间最强的存在。',
    descriptionLong: '一粒尘可填海，一根草斩尽日月星辰。大荒之中，少年石昊体内天生一块至尊骨，却被人残忍夺走。为了寻找父母的下落，为了变得更强，石昊从石村出发，踏入广阔无垠的修真世界。他以顽强的意志和不屈的精神，闯过重重险境，战胜无数强敌，一步步揭开上古时代最深刻的秘密，最终走向那令人向往的完美世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20poster%2C%20mythical%20ancient%20world%20theme%2C%20young%20warrior%20in%20wilderness%2C%20golden%20celestial%20light%2C%20epic%20warm%20tones%2C%20professional%20anime%20poster%20design%2C%20clean%20background&width=400&height=560&seq=movie-cover-013&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mythical%20ancient%20Chinese%20wilderness%20landscape%2C%20golden%20celestial%20light%20breaking%20through%20clouds%2C%20epic%20fantasy%20world%2C%20warm%20amber%20atmosphere%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-013&orientation=landscape',
    episodes: '更新至第150集',
    status: '连载中',
    actors: ['钱琛', '杨天翔', '乔诗语', '张杰'],
    director: '汪成果',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2024-04-01',
    updateInfo: '2026-08-02 更新至第150集',
    isHot: false,
    isNew: false,
  },
  {
    id: 'anime-003',
    title: '一念永恒',
    category: 'anime',
    subCategory: '修仙/喜剧',
    year: 2026,
    rating: 8.3,
    description: '平凡少年白小纯为追求长生，踏入修仙宗门灵溪宗，凭借自己独特的"怕死"哲学，在修仙界掀起一阵风暴。',
    descriptionLong: '白小纯是一个怕死的普通少年，为了追求长生不老，他带着一只会说话的乌龟，踏上了前往灵溪宗的修仙之路。与其他修仙者不同的是，白小纯的修炼哲学是"活着才是硬道理"。他凭借着独特的思维方式和出人意料的行动，在修仙界搞得天翻地覆，却总能在关键时刻化险为夷。这是一部充满欢乐与感动的修仙喜剧动画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20comedy%20anime%20poster%2C%20young%20disciple%20in%20daoist%20robe%2C%20misty%20mountain%20temple%2C%20playful%20and%20warm%20atmosphere%2C%20professional%20anime%20poster%20design%2C%20clean%20background&width=400&height=560&seq=movie-cover-014&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Misty%20Chinese%20mountain%20temple%20complex%2C%20daoist%20cultivation%20atmosphere%2C%20floating%20clouds%20around%20peaks%2C%20warm%20golden%20morning%20light%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-014&orientation=landscape',
    episodes: '更新至第66集',
    status: '连载中',
    actors: ['苏尚卿', '沈念如', '马正阳', '赵毅'],
    director: '苏晓光',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-10-01',
    updateInfo: '2026-08-01 更新至第66集',
    isHot: false,
    isNew: true,
  },
  {
    id: 'anime-004',
    title: '仙逆',
    category: 'anime',
    subCategory: '修仙/玄幻',
    year: 2026,
    rating: 8.7,
    description: '平凡少年王林凭借一枚神秘石珠「天逆」，踏上逆天修仙之路，以坚韧不拔的意志打破命运的枷锁。',
    descriptionLong: '资质平庸的少年王林，偶然得到一枚神秘的石珠"天逆"。这枚石珠拥有逆转时间和空间的神奇能力。从此，王林的命运发生了翻天覆地的变化。他以远超常人的毅力和决心，在修仙的道路上不断突破自我。逆天改命，顺为凡，逆则仙。王林用自己的行动证明了：命运从来都不是注定的，只要有足够的勇气和决心，平凡之人也能成就非凡之事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%2C%20mysterious%20stone%20bead%20glowing%2C%20dark%20and%20dramatic%20atmosphere%2C%20immortal%20cultivation%20theme%2C%20warm%20golden%20energy%20effects%2C%20professional%20anime%20poster%20design&width=400&height=560&seq=movie-cover-015&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mysterious%20celestial%20realm%20with%20floating%20islands%2C%20ancient%20cultivation%20world%2C%20dramatic%20sky%20with%20energy%20vortex%2C%20warm%20golden%20and%20dark%20tones%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-015&orientation=landscape',
    episodes: '更新至第48集',
    status: '连载中',
    actors: ['马正阳', '赵路', '杨天翔', '张杰'],
    director: '石头熊',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-02-14',
    updateInfo: '2026-08-02 更新至第48集',
    isHot: true,
    isNew: true,
  },
  {
    id: 'variety-004',
    title: '哈哈哈哈哈·第5季',
    category: 'variety',
    subCategory: '旅行真人秀',
    year: 2026,
    rating: 8.2,
    description: '邓超、陈赫、鹿晗等好友组团开启全国公路旅行，在旅途中体验不同城市的生活，收获欢笑与感动。',
    descriptionLong: '《哈哈哈哈哈》第五季，邓超、陈赫、鹿晗等好友再度集结，开启了一场跨越全国的公路旅行。他们在旅途中体验各行各业的真实工作，品尝各地的特色美食，感受不同城市的风土人情。节目采用无剧本模式，记录下旅途中最真实的笑声和情感。这不仅是一场旅行，更是一段关于友谊、成长和生活的温暖故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20road%20trip%20variety%20show%20poster%2C%20friends%20traveling%20together%2C%20bright%20sunny%20day%2C%20cheerful%20and%20fun%20atmosphere%2C%20warm%20natural%20lighting%2C%20professional%20show%20poster%20design%2C%20clean%20background&width=400&height=560&seq=movie-cover-016&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Scenic%20Chinese%20highway%20through%20mountains%2C%20bright%20sunny%20day%2C%20road%20trip%20adventure%2C%20cheerful%20travel%20atmosphere%2C%20warm%20golden%20light%2C%20cinematic%20wide%20shot%2C%20hero%20banner%20composition&width=1400&height=600&seq=movie-banner-016&orientation=landscape',
    episodes: '更新至第12期',
    status: '连载中',
    actors: ['邓超', '陈赫', '鹿晗', '王勉', '范志毅'],
    director: '王征宇',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-03-14',
    updateInfo: '2026-08-01 更新至第12期',
    isHot: false,
    isNew: false,
  },
];

export const categoryInfo = {
  movie: { name: '电影', icon: 'ri-film-line', description: '最新电影大片，院线热映佳片一网打尽' },
  tv: { name: '电视剧', icon: 'ri-tv-line', description: '热门电视剧集，追剧不等待' },
  variety: { name: '综艺', icon: 'ri-live-line', description: '热门综艺节目，欢笑不断' },
  anime: { name: '动漫', icon: 'ri-rocket-line', description: '精彩动漫番剧，二次元盛宴' },
};